import React from 'react';
import { ViewDishState } from './viewDishState/ViewDishState';
import { ViewForm } from './components/ViewForm';
import { ModalWindows } from './components/ModalWindows';

export const ViewDishPageV2: React.FC = () => {
	return (
		<ViewDishState>
			<ViewForm />
			<ModalWindows />
		</ViewDishState>
	);
};
